var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 16.0003C20.0001 18.2095 18.2092 20.0003 16.0001 20.0003C13.7909 20.0003 12.0001 18.2095 12.0001 16.0003C12.0001 13.7912 13.7909 12.0003 16.0001 12.0003C18.2092 12.0003 20.0001 13.7912 20.0001 16.0003Z",
    stroke: "#191E1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5646 14.6652L27.7746 12.3184C27.5258 11.5221 27.1985 10.7604 26.8016 10.0425L26.572 9.64479C26.14 8.92764 25.637 8.25803 25.0728 7.64568L21.4377 9.25124C20.7465 8.69373 19.968 8.24021 19.1259 7.91446L18.6988 3.96312C17.8302 3.76926 16.9271 3.66699 16.0002 3.66699C15.0731 3.66699 14.17 3.76927 13.3014 3.96316L12.8742 7.91454C12.0322 8.2403 11.2537 8.69381 10.5626 9.25129L6.92749 7.64574C6.36136 8.26022 5.85686 8.93235 5.4238 9.65232L5.20297 10.0348C4.80422 10.755 4.47543 11.5193 4.22577 12.3185L7.43571 14.6653C7.36843 15.1004 7.33352 15.5463 7.33352 16.0003C7.33352 16.4543 7.36843 16.9002 7.43571 17.3354L4.22577 19.6821C4.47543 20.4814 4.80423 21.2457 5.20299 21.9659L5.42378 22.3483C5.85685 23.0683 6.36135 23.7404 6.92749 24.3549L10.5626 22.7494C11.2537 23.3068 12.0322 23.7603 12.8742 24.0861L13.3014 28.0375C14.17 28.2314 15.0731 28.3337 16.0002 28.3337C16.9271 28.3337 17.8302 28.2314 18.6988 28.0375L19.1259 24.0862C19.968 23.7604 20.7465 23.3069 21.4377 22.7494L25.0728 24.355C25.637 23.7426 26.14 23.073 26.5721 22.3558L26.8016 21.9582C27.1984 21.2403 27.5258 20.4786 27.7746 19.6822L24.5646 17.3355C24.6319 16.9003 24.6669 16.4544 24.6669 16.0003C24.6669 15.5463 24.6319 15.1004 24.5646 14.6652Z",
    stroke: "#191E1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStetting);
export default __webpack_public_path__ + "static/media/stetting.0b17247bb349531fc2b531d063025623.svg";
export { ForwardRef as ReactComponent };